import { Component, OnInit } from '@angular/core';
import { HomeService } from 'src/app/utils/services/home/home.service';

@Component({
  selector: 'app-register-for-business',
  templateUrl: './register-for-business.component.html',
  styleUrls: ['./register-for-business.component.scss']
})
export class RegisterForBusinessComponent implements OnInit {

  constructor(
    private homeService: HomeService
  ) { }

  data: any = null;

  ngOnInit(): void {
    this.getData();
  }

  getData() {
    this.homeService.getDataByCodeCategory("esolManual", "vi").subscribe((res: any) => {
      this.data = res?.object?.item || {};
    });
  }
}
